import React, { ReactNode, createContext, useContext } from 'react';

interface ArticleListingUrlContextI {
  allArticles: string;
}

const defaultContext: ArticleListingUrlContextI = {
  allArticles: '/news/all-articles',
};

const ArticleListingUrlContext = createContext<ArticleListingUrlContextI>(defaultContext);

export const ArticleListingUrlContextProvider = ({
  allArticles,
  children,
}: {
  allArticles: string;
  children: ReactNode;
}) => {
  return <ArticleListingUrlContext.Provider value={{ allArticles }}>{children}</ArticleListingUrlContext.Provider>;
};

export const useArticleListingUrl = () => useContext(ArticleListingUrlContext);
